import {$swoole} from './axios.setup'

// getArticles
// - 2023.07.11
// - new articles api for Vue 3 migration
export const getArticles = async () => {
  try {
    const url = `/v1/articles`
    const res = await $swoole.get(url)

    return res.data
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// getArticle
// - 2023.07.26
// - New article api for Vue 3 migration
export const getArticle = async ({params}) => {
  try {
    const url = `/v1/article/${params.id}`
    const res = await $swoole.get(url)

    return res.data
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}
